"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/MembersTab/components/Modals/RemoveMember/Form.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _useOrgAccount = require('shared/hooks/useOrgAccount');

var _noticeBar = require('web/services/context/noticeBar');
var _Modal = require('web/components/Modal');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);












const RemoveMemberModal = ({
  onClose, entity, onProceed, orgKey, orgName,
}) => {
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  // In a flagged account, removing an account-owned person from their only
  // org deletes their user (D-60, E-37); the dialog says so first. Remove
  // waits for the answer.
  const [wouldDeleteUser, setWouldDeleteUser] = _react.useState.call(void 0, false)
  const [hasImpact, setHasImpact] = _react.useState.call(void 0, false)
  const userKey = entity.wrappedEntity.UserKey

  _react.useEffect.call(void 0, 
    () => {
      let isCurrent = true
      _actions2.default.getMemberRemovalImpact({ OrgKey: orgKey, UserKey: userKey })
        .then(r => { if (isCurrent) setWouldDeleteUser(!!_optionalChain([r, 'optionalAccess', _ => _.WouldDeleteUser])) })
        .catch(() => undefined) // the server still refuses an unconfirmed delete
        .finally(() => { if (isCurrent) setHasImpact(true) })
      return () => { isCurrent = false }
    },
    [orgKey, userKey],
  )

  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const onSubmit = () => {
    setIsLoading(true)
    onProceed(wouldDeleteUser)
      .then(() => showSuccessBar("Successfully removed user from the organization."))
      .then(onClose)
      .catch(e => {
        setIsLoading(false)
        // Removing them would delete their user: ask again with that copy.
        if (!wouldDeleteUser && _useOrgAccount.isConfirmDeleteUserError.call(void 0, e)) setWouldDeleteUser(true)
        else showWarningBar("Failed to remove user from the organization.")
      })
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , wouldDeleteUser
        ? (
          _react2.default.createElement('span', { className: "settings--org-members--remove-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}},  _useOrgAccount.deleteUserNotice.call(void 0, orgName) )
          )
        : (
          _react2.default.createElement('span', { className: "settings--org-members--remove-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, "You are about to remove "
                 , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  entity.name ), " from "  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  orgName ), "."
          )
          )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnTheme: "danger",
        primaryBtnLabel: wouldDeleteUser ? _useOrgAccount.REMOVE_AND_DELETE_USER_LABEL : 'Remove',
        isPrimaryEnabled: hasImpact,
        isPrimaryLoading: isLoading,
        onPrimaryBtnClick: onSubmit,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
      )
    )
  )
}

exports. default = RemoveMemberModal
